module.exports = __webpack_public_path__ + "img/heat-detector.09f110a4.svg";